/** The address of a type's editor page (1.B-2 provides; 1.N-2 and 1.S link to it). */
export function typeHref(key: string): string {
  return `/types/${encodeURIComponent(key)}`;
}
